import { RadarEntry, RadarRing, RadarQuadrant } from './types'
import {
  TechRadarApi,
  TechRadarLoaderResponse
} from '@backstage-community/plugin-tech-radar'
import { RINGS, QUADRANTS } from './techRadarData'
import { AI_RINGS, AI_QUADRANTS } from './aiTechRadarData'

function buildRadarData(
  ringsObj: Record<string, any>,
  quadrantsObj: Record<string, any>
): TechRadarLoaderResponse {
  const rings = new Array<RadarRing>()
  for (const [_, { id, name, color }] of Object.entries(ringsObj)) {
    rings.push({ id, name, color })
  }

  const quadrants = new Array<Omit<RadarQuadrant, 'entries'>>()
  let entries = new Array<RadarEntry>()
  for (const [_, { id, name, entries: quadrantEntries }] of Object.entries(
    quadrantsObj
  )) {
    quadrants.push({ id, name })
    entries = [
      ...entries,
      ...quadrantEntries.map((entry: RadarEntry) => ({ ...entry, quadrant: id }))
    ]
  }

  return { entries, quadrants, rings }
}

const defaultData = buildRadarData(RINGS, QUADRANTS)
const aiData = buildRadarData(AI_RINGS, AI_QUADRANTS)

export class DataTechRadarApi implements TechRadarApi {
  async load(id: string | undefined) {
    if (id === 'ai') {
      return aiData
    }
    return defaultData
  }
}
